import React, { useEffect } from 'react'
import { Grid, Pagination, InputLabel, Select, MenuItem } from '@deere/fuel-react';


export const ListPagination = ({ list, authState, component }) => {
    const Component = component;
    const [itemsPerPage, setItemsPerPage] = React.useState(10);
    const [page, setPage] = React.useState(1);
    const [noOfPages, setNoOfPages] = React.useState(0);
    const [noOfResults, setNoOfResults] = React.useState(0);

    const handleChange = (event, value) => {
        setPage(value);
    };

    const handleSelectChange = (e) => {
        setItemsPerPage(e.target.value);
        setNoOfPages(Math.ceil(list.length / e.target.value));
        setPage(1);
    };

    useEffect(() => {
        if (list) {
            setNoOfPages(Math.ceil(list.length / itemsPerPage))
            setNoOfResults(list.length)
        }
    }, [itemsPerPage, list])

    return (
        <Grid container spacing={4} sx={{ mt: -1 }}>
            <Grid xs={12} md={12} item>
                <h5>{noOfResults === 1 ? `${noOfResults} Result` : `${noOfResults} Results`}</h5>
                {
                    list && list.length > 0 ? list
                        .slice((page - 1) * itemsPerPage, page * itemsPerPage)
                        .map((item, index) => (
                            <Component item={item} key={index} index={index} authState={authState} />
                        )).sort() : null
                }
            </Grid>
            <Grid item container spacing={4} alignItems="center">
                <Grid
                    item
                    sx={(theme) => ({
                        width: "200px",
                        color: "#666666",
                        fontSize: ".875rem",
                        [theme.breakpoints.down("md")]: {
                            display: "none",
                        },
                    })}
                >
                    {"Results "}
                    {page}-{noOfPages}
                </Grid>
                <Grid item xs sx={{ textAlign: "center" }}>
                    <Pagination
                        sx={{ display: "inline-table" }}
                        count={noOfPages}
                        page={page}
                        onChange={handleChange}
                        breakpoint={900}
                    />
                </Grid>
                <Grid
                    item
                    sx={(theme) => ({
                        with: "200px",
                        textAlign: "left",
                        color: "#666666",
                        fontSize: ".875rem",
                        [theme.breakpoints.down("md")]: {
                            display: "none",
                        },
                    })}
                >
                    <InputLabel
                        id="selectItemsPerPage-select-label"
                        sx={{
                            color: "#666666",
                            fontSize: ".875rem",
                            fontWeight: "normal",
                            display: "inline-grid",
                            paddingRight: ".5rem",
                        }}
                    >
                        Items per page
                    </InputLabel>
                    <Select
                        className="selectItemsPerPage"
                        defaultValue={10}
                        id="selectItemsPerPage"
                        labelId="selectItemsPerPage"
                        onChange={handleSelectChange}
                        sx={{
                            color: "#666666",
                            fontSize: ".875rem",
                            display: "inline-grid"
                        }}
                    >
                        <MenuItem value={10}>{"10"}</MenuItem>
                        <MenuItem value={25}>{"25"}</MenuItem>
                        <MenuItem value={50}>{"50"}</MenuItem>
                        <MenuItem value={100}>{"100"}</MenuItem>
                    </Select>
                </Grid>
            </Grid>
        </Grid>
    );
}